import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { GoodBase } from './GoodBase';

export class Good extends GoodBase {
    _originalTypeClassName = "zERP.BO.Good";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Good.translate = translateService;
}
super();
this.PackagingUnits = [];
this.Availability = null;
this.SKU = null;
this.TrackStock = true;
this.ValuationMethod = null;
this.MinimumStock = null;
this.ReorderThreasholdStock = null;
this.PurchasePrice = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
Availability:any;
SKU:any;
TrackStock:any;
ValuationMethod:any;
MinimumStock:any;
ReorderThreasholdStock:any;
PurchasePrice:any;
MeasurementUnitValueObject:any;
GoodCat:any;
PackagingUnitValueObject:any;
PackagingUnits:any;
GoodSubCat:any;
static setMeasurementUnitValueObject = ($this, value) => {
var oldValue = $this.MeasurementUnitValueObject;
$this.MeasurementUnitValueObject = value;
if (value != null) {
}
}
static setGoodCat = ($this, value) => {
var oldValue = $this.GoodCat;
$this.GoodCat = value;
if (value != null) {
}
}
static setPackagingUnitValueObject = ($this, value) => {
var oldValue = $this.PackagingUnitValueObject;
$this.PackagingUnitValueObject = value;
if (value != null) {
}
}
static setPackagingUnits = ($this, items) => {
                if (items == null) items = [];
                if ($this.PackagingUnits == null) $this.PackagingUnits = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PackagingUnits.length > 0) {
                    Domain.Good.removePackagingUnits($this, $this.PackagingUnits[0]);
                }

                Domain.Good.addManyPackagingUnits($this, copyItems);
            }
static addManyPackagingUnits = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Good.addPackagingUnits($this, items[i]);
                }
            }
static addPackagingUnits = ($this, item) => {
                if ($this.PackagingUnits == null) $this.PackagingUnits = [];
                if (item == null || $this.PackagingUnits.indexOf(item) > -1) return;
                $this.PackagingUnits.push(item);
if (item.Good != $this) {
Domain.GoodPackagingUnit.setGood(item, $this);
}
}
static addRangePackagingUnits = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Good.addPackagingUnits($this, item));
            }
static removePackagingUnits = ($this, item) => {
                if ($this == null || $this.PackagingUnits == null || $this.PackagingUnits.indexOf(item) === -1) return;
                var _index = $this.PackagingUnits.indexOf(item);
                $this.PackagingUnits.splice(_index, 1);
item.Good = null;
}
static clearPackagingUnits = ($this) => { $this.PackagingUnits = null; }
static setGoodSubCat = ($this, value) => {
var oldValue = $this.GoodSubCat;
$this.GoodSubCat = value;
if (value != null) {
}
}

static GetCodeClassName(): any{return "Good";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}